// extracted by mini-css-extract-plugin
export var button = "_404-module--button--IOGaR";
export var image = "_404-module--image--Yql3g";
export var imageWrapper = "_404-module--imageWrapper--lWL0Q";
export var label = "_404-module--label--oequG";
export var preamble = "_404-module--preamble--WEk4y";
export var title = "_404-module--title--M5d9C";
export var wrapper = "_404-module--wrapper--IWuHh";